import WillgoLogo from '../../WillgoLogo.png';
import LOGO_PLACEHOLDER from "../../LOGO_PLACEHOLDER.jpg";

import {Mail} from "lucide-react";

const Type2FooterCard = (props) => {

    const {
        bookingEngine,
        _company_name,
        logo_url,
    } = props;

    return <footer style={{backgroundColor: bookingEngine?.headerBg}} className="bg-gray-900 text-white py-20 px-6">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="col-span-1 md:col-span-2">
            {
                !bookingEngine?.hideCompanyLogo &&
                <p style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
                    <img style={{width: 70, height: 70, borderRadius: `${bookingEngine?.headerLogoBorderRadius}%`}} 
                        src={(logo_url || LOGO_PLACEHOLDER)}/>
                </p>
            }
            {
                !bookingEngine?.hideCompanyName &&
                <h2 style={{color: bookingEngine?.headerCompanyTxtColor}} className="text-2xl font-bold mb-6">
                    
                    <>
                        {         
                            _company_name ||
                            "Business Name"
                        }
                    </>
                </h2>
            }
            <p style={{color: bookingEngine?.headerMenuTxtColor}} className="text-gray-400 max-w-md leading-relaxed">
              Curating exclusive travel experiences across Ghana and beyond. 
              Our mission is to provide seamless, enriching, and unforgettable journeys.
            </p>
          </div>
          <div>
            <h4 style={{color: bookingEngine?.greetingsCardTitleColor}} className="text-xs font-bold uppercase tracking-widest text-gray-500 mb-6">
                Quick Links</h4>
            <ul className="space-y-4 text-sm font-medium text-gray-400">
              <li style={{color: bookingEngine?.headerMenuTxtColor}} className="hover:text-white cursor-pointer transition-colors">
                My Itineraries</li>
              <li style={{color: bookingEngine?.headerMenuTxtColor}} className="hover:text-white cursor-pointer transition-colors">
                Support Center</li>
              <li style={{color: bookingEngine?.headerMenuTxtColor}} className="hover:text-white cursor-pointer transition-colors">
                Terms of Service</li>
              <li style={{color: bookingEngine?.headerMenuTxtColor}} className="hover:text-white cursor-pointer transition-colors">
                Privacy Policy</li>
            </ul>
          </div>
          <div>
            <h4 style={{color: bookingEngine?.greetingsCardTitleColor}} className="text-xs font-bold uppercase tracking-widest text-gray-500 mb-6">
                Newsletter</h4>
            <div className="flex gap-2">
                <div className="flex-1 flex items-center gap-2 bg-slate-50 border border-slate-200 rounded-lg px-3 py-2">
                    <Mail size={14} className="text-slate-400" />
                    <input 
                    type="email" 
                    placeholder="Email address" 
                    className="bg-transparent border-none outline-none text-xs w-full text-slate-900"
                    />
                </div>
              <button style={{border: "none", backgroundColor: bookingEngine?.actionButtonsBg, color: bookingEngine?.actionButtonsTxtColor}} className="bg-orange-600 hover:bg-orange-700 px-4 py-2 rounded-lg text-sm font-bold transition-colors">
                Join
              </button>
            </div>
          </div>
        </div>
        <div style={{color: bookingEngine?.greetingsCardSecTextColor}} className="max-w-6xl mx-auto mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-gray-500 font-bold uppercase tracking-widest">
          <span className='text-xs'>
            © 2026 Trip Bespoke. All rights reserved.</span>
          <div className="flex gap-6">
            <span className='text-xs'>
                Instagram</span>
            <span className='text-xs'>
                Twitter</span>
            <span className='text-xs'>
                LinkedIn</span>
          </div>
        </div>
    </footer>
}

export default Type2FooterCard;